var _defs, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _path, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _path2, _use73, _use74, _use75, _use76, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149.42mm",
    height: "149.42mm",
    viewBox: "0 0 149.4234 149.4234",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4596",
    x1: 1008.8,
    x2: 948.32,
    y1: 197.65,
    y2: 972.8,
    gradientTransform: "matrix(.91314 0 0 .91314 153.04 9.3705)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.42667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.59333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4604",
    x1: 1313.8,
    x2: 766.75,
    y1: 573.56,
    y2: 629.52,
    gradientTransform: "matrix(.89886 0 0 .89886 165.66 17.671)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.61496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4630",
    x1: 1313.8,
    x2: 696.51,
    y1: 573.56,
    y2: 599.87,
    gradientTransform: "matrix(.89886 0 0 .89886 -1852.6 -827.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.51763
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4642",
    x1: 956.84,
    x2: 717.79,
    y1: 1130.9,
    y2: 115.67,
    gradientTransform: "matrix(.8 0 0 .8 -1765.2 -770.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-62.872 -51.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -116.42 -16.72)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 540,
    r: 282.37,
    fill: "url(#linearGradient4596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1238 540a277.96 277.96 0 0 1 -277.96 277.96 277.96 277.96 0 0 1 -277.96 -277.96 277.96 277.96 0 0 1 277.96 -277.96 277.96 277.96 0 0 1 277.96 277.96z",
    fill: "url(#linearGradient4604)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(193.25)",
    d: "m-780.25-305.6a277.96 277.96 0 0 1 -277.96 277.96 277.96 277.96 0 0 1 -277.96 -277.96 277.96 277.96 0 0 1 277.96 -277.96 277.96 277.96 0 0 1 277.96 277.96z",
    fill: "url(#linearGradient4630)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(193.25)",
    d: "m-810.82-305.6a247.39 247.39 0 0 1 -247.39 247.39 247.39 247.39 0 0 1 -247.39 -247.39 247.39 247.39 0 0 1 247.39 -247.39 247.39 247.39 0 0 1 247.39 247.39z",
    fill: "url(#linearGradient4642)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(193.25)",
    d: "m-817.18-305.6a241.03 241.03 0 0 1 -241.03 241.03 241.03 241.03 0 0 1 -241.03 -241.03 241.03 241.03 0 0 1 241.03 -241.03 241.03 241.03 0 0 1 241.03 241.03z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4683",
    d: "m958.55 306.44h2.9155v9.2324h-2.9155z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(193.25)",
    d: "m-1057.8-305.61a0.42123 0.42123 0 0 1 -0.4213 0.42123 0.42123 0.42123 0 0 1 -0.4212 -0.42123 0.42123 0.42123 0 0 1 0.4212 -0.42123 0.42123 0.42123 0 0 1 0.4213 0.42123z",
    fill: "#f00"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(6 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(12 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(18 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(24 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(30 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(36 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(42 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(48 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(54 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(60 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(66 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(78 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(84 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(96 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(102 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(108 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(114 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(120 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(126 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(132 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(138 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(150 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(156 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(162 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(168 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(174 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(186 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(192 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(198 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(204 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(210 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(216 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(222 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(228 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(234 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(240 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(246 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(252 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(258 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(264 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-90 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-84 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-78 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-72 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-66 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-60 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-54 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-48 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-42 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-36 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-30 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-24 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-18 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-12 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-6 960 540.02)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect4683"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect5173",
    d: "m956.82 306.09h6.364v24.749h-6.364z"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(30 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(60 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(120 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(150 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(210 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(240 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-90 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-60 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-30 960 540.03)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5173"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect5199",
    d: "m953.99 305.03h12.021v34.648h-12.021z"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5199"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90 960 540)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5199"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180 960 540)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5199"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-90 960 540)",
    width: "100%",
    height: "100%",
    xlinkHref: "#rect5199"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m943.45 355.35v45.809h-6.5487v-39.26h-7.8584v-6.5487z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.75 361.9v5.9098h-6.5487v-5.9098q0-1.3417 0.51111-2.5236 0.51112-1.2139 1.4056-2.0764 0.89446-0.89446 2.0764-1.4056 1.2139-0.54307 2.5556-0.54307h20.732q1.3417 0 2.5236 0.54307 1.2139 0.51111 2.0764 1.4056 0.89446 0.86251 1.4056 2.0764 0.54306 1.182 0.54306 2.5236v8.3696q0 1.3417-0.25556 2.3959t-0.83056 1.9167q-0.54307 0.83057-1.4056 1.5014t-2.1084 1.2778l-22.681 10.638v6.6126h21.563v-5.8778h6.5487v12.427h-34.66v-12.043q0-1.3417 0.25556-2.3959 0.2875-1.0542 0.83056-1.8848 0.54307-0.83056 1.4056-1.5014 0.89445-0.70279 2.0764-1.2778l22.713-10.67v-9.4876z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1106.1 550.68h6.4209v2.4278q0 2.5875 1.15 3.8014 1.15 1.2139 3.7695 1.2139h13.193q2.6195 0 3.7695-1.2139 1.15-1.2139 1.15-3.8014v-3.5459q0-2.6195-1.15-3.8014t-3.7695-1.182h-13.545v-6.389h13.353q2.3958-0.0958 3.4181-1.2778 1.0541-1.2139 1.0541-3.7056v-3.0028q0-2.6195-1.1819-3.8334-1.15-1.2139-3.7376-1.2139h-11.915q-2.5875 0-3.7375 1.2139-1.1501 1.2139-1.1501 3.8334v2.4278h-6.4209v-2.7473q0-11.149 11.117-11.149h12.299q5.6542 0 8.3696 2.7473 2.7472 2.7473 2.7472 8.4015v0.83057q0 3.8653-1.3736 6.389-1.3417 2.4917-3.9292 3.7056 2.907 0.86251 4.4403 3.45 1.5334 2.5875 1.5334 6.8682v2.3q0 11.117-11.117 11.117h-13.608q-11.149 0-11.149-11.117z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m814.36 552.53q0 1.3417-0.51112 2.5556-0.51112 1.182-1.4056 2.0764-0.89446 0.89446-2.1084 1.4056-1.182 0.51111-2.5236 0.51111h-20.924q-1.3417 0-2.5556-0.51111-1.182-0.51112-2.0764-1.4056-0.89446-0.89445-1.4056-2.0764-0.51112-1.2139-0.51112-2.5556v-5.8779h6.5487v5.8779h20.924v-13.065h-20.924q-1.3417 0-2.5556-0.51111-1.182-0.54307-2.0764-1.4056-0.89446-0.89445-1.4056-2.0764-0.51112-1.2139-0.51112-2.5556v-13.097q0-1.3417 0.51112-2.5236 0.51112-1.2139 1.4056-2.0764 0.89445-0.89446 2.0764-1.4056 1.2139-0.54307 2.5556-0.54307h20.924q1.3417 0 2.5236 0.54307 1.2139 0.51111 2.1084 1.4056 0.89445 0.86251 1.4056 2.0764 0.51112 1.182 0.51112 2.5236zm-6.5487-19.614v-13.097h-20.924v13.097z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m943.13 681.75q0-1.3417 0.51111-2.5236 0.51112-1.2139 1.4056-2.0764 0.89445-0.89445 2.0764-1.4056 1.2139-0.54307 2.5556-0.54307h20.924q1.3417 0 2.5236 0.54307 1.2139 0.51112 2.1084 1.4056 0.89445 0.86251 1.4056 2.0764 0.51112 1.182 0.51112 2.5236v5.9098h-6.5487v-5.9098h-20.924v13.097h20.924q1.3417 0 2.5236 0.51112 1.2139 0.51111 2.1084 1.4056 0.89445 0.89446 1.4056 2.1084 0.51112 1.182 0.51112 2.5236v13.065q0 1.3417-0.51112 2.5556-0.51112 1.182-1.4056 2.0764-0.89446 0.89446-2.1084 1.4056-1.182 0.51111-2.5236 0.51111h-20.924q-1.3417 0-2.5556-0.51111-1.182-0.51112-2.0764-1.4056-0.89446-0.89445-1.4056-2.0764-0.51111-1.2139-0.51111-2.5556zm6.5487 19.646v13.065h20.924v-13.065z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 580.90204,
    y: 684.62366,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    letterSpacing: "0px",
    strokeWidth: "1px",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 580.90204,
    y: 720.01428
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial);
export default __webpack_public_path__ + "static/media/dial.d0481366f310a0a24516fdc2e0e9b266.svg";
export { ForwardRef as ReactComponent };